<div class="container-fluid">
  <div class="row justify-content-between">
    <div class="col-xl-6 mt-0 mt-md-4 widget-wrapper">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2 class="mr-0">
            <info-tooltip2 class="mx-2" title="User Engagement" color="white"></info-tooltip2>
            <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
          </h2>
          <app-new-tag class="ml-auto my-auto"></app-new-tag>
          <div class="mt-2">
            <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
          </div>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-user-engagement [data]="data"></domain-user-engagement>
        </div>
      </div>
    </div>
    <div class="col-xl-6 mt-4 widget-wrapper">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>
            <info-tooltip2 class="mx-2" title="Ad Performance" color="white"></info-tooltip2>
          </h2>
          <app-new-tag class="ml-auto my-auto"></app-new-tag>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-ad-performance [data]="data"></domain-ad-performance>
        </div>
      </div>
    </div>
    <div class="col-xl-6 mt-4 widget-wrapper">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>
            <info-tooltip2 class="mx-2" title="User Behavior" color="white"></info-tooltip2>
            <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
          </h2>
          <app-new-tag class="ml-auto my-auto"></app-new-tag>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-user-behavior [data]="data"></domain-user-behavior>
        </div>
      </div>
    </div>
    <div class="col-xl-6 mt-4 widget-wrapper">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>
            <info-tooltip2 class="mx-2" title="Cross Platform Distribution" color="white"></info-tooltip2>
            <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
          </h2>
          <app-new-tag class="ml-auto my-auto"></app-new-tag>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <domain-contribution-platform [data]="data"></domain-contribution-platform>
        </div>
      </div>
    </div>
  </div>
</div>